export default function PHP_abs() {
  return (
    <div>
      <h1>PHP_abs</h1>
    </div>
  );
}
